const DEFAULT_DOCUMENT_STORAGE_KEY = "certificate-builder:current-design:v1";
const DEFAULT_SAMPLE_DATA_STORAGE_KEY = "certificate-builder:current-sample-data:v1";

export const getCertificateDesignStorageKey = (xsdId, xsdVersion) => {
    if (xsdId === null || xsdId === undefined || xsdId === "") return DEFAULT_DOCUMENT_STORAGE_KEY;

    const encodedXsdId = encodeURIComponent(xsdId);
    if (xsdVersion === null || xsdVersion === undefined || xsdVersion === "") {
        return `certificate-builder:xsd:${encodedXsdId}:design:v1`;
    }
    return `certificate-builder:xsd:${encodedXsdId}:version:${encodeURIComponent(xsdVersion)}:design:v1`;
};

export const getCertificateSampleDataStorageKey = (xsdId, xsdVersion) => {
    if (xsdId === null || xsdId === undefined || xsdId === "") return DEFAULT_SAMPLE_DATA_STORAGE_KEY;

    const encodedXsdId = encodeURIComponent(xsdId);
    if (xsdVersion === null || xsdVersion === undefined || xsdVersion === "") {
        return `certificate-builder:xsd:${encodedXsdId}:sample-data:v1`;
    }
    return `certificate-builder:xsd:${encodedXsdId}:version:${encodeURIComponent(xsdVersion)}:sample-data:v1`;
};

export const hasSavedCertificateDesign = (xsdId, xsdVersion, storage = window.localStorage) => {
    if (xsdId === null || xsdId === undefined || xsdId === "") return false;

    try {
        const savedDocument = storage.getItem(getCertificateDesignStorageKey(xsdId, xsdVersion));
        if (!savedDocument) return false;

        const document = JSON.parse(savedDocument);
        return Array.isArray(document.elements) && Boolean(document.pageStyle);
    } catch {
        return false;
    }
};